<template>

  <div class="data-table">
<div class="control">
<button class="button devils is-small" @click="fetchData"> Load Data </button>
</div>

    <div class="main-table">
        <table class="table">
            <thead>
                <tr>
                    <th class="table-head" data-tooltip="Tooltip" v-for="column in columns" :key="column" @click="sortByColumn(column)">
                      {{column | columnHead}} 
                        <span v-if="column === sortedColumn">
                            <i v-if="order == 'asc'"> &#x25B2;</i>
                            <i v-else>&#x25BC;</i>
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="" v-if="tableData.length === 0">
                    <td class="lead text-center" :colspan="columns.length + 1">No data found.</td>
                </tr>
                <tr v-for="data in tableData" :key="data.id" v-else>
                    <td v-for="(value, key) in data" :key="key">{{ value }}</td>
                </tr>

            </tbody>
        </table>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    endpoint: { type: String, required: true },
    selectedData: { type: Array, required: true },
    postData: { type: Array, required: false },
    defaultSort: {type: String, required: false}
  },
  data () {
    return {
      tableData: [],
      columns: [],
      url: '',
      sortedColumn: '',
      test: false,
      order: 'asc'
    }
  },
  watch: {
    endpoint: {
      handler: function (endpoint) {
        this.url = endpoint
      },
      immediate: true
    },
    postData: {
      handler: function (postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchData()
      },
      immediate: true
    }
  },
  methods: {
    fetchData () {
      if (this.postData != null) {
        // console.log('data: ' + JSON.stringify(this.postData) + ' url: ' + this.url)
        this.$http
        .post(this.url, this.postData[0], {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            // console.log('response was: ' + response.data)
            this.tableData = response.data
            this.$emit('dataLoaded', this.tableData)
            this.tableData = this.mapData()
            this.test = false
            this.sortByColumn('Total TOI')
          },
          response => {}
        )
      } else {
        this.$http.get(this.url, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }}).then(
          response => {
            this.tableData = response.data
            this.tableData = this.mapData()
            // this.sortByColumn(this.defaultSort)
          }
        )
      }
    },
    mapData () {
      this.select = _.map(this.selectedData, 'prop')
      this.columns = _.map(this.selectedData, 'title')
      return _.reverse(_.map(this.tableData, _.partial(_.pick, _, this.select)))
    },
    sortByColumn (column) {
      // Get keys
      console.log('Column to sort: ' + column)
      let selected = _.find(this.selectedData, { 'title': column })
      this.test = !this.test
      if (this.test) {
        this.order = 'desc'
      } else {
        this.order = 'asc'
      }
      this.tableData = _.orderBy(this.tableData, selected.prop, [this.order])
      // console.log(JSON.stringify(this.tableData))
      this.sortedColumn = column
    }
  },
  created () {
    return this.fetchData()
  },
  filters: {
    columnHead (value) {
      return value.split('_').join(' ').toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
thead, th {
    background-color: #8b0505d1;
}
.table tr:hover {
    background-color: #8b0505d1;
    color: #fff;
    margin: 0 auto;
}
.table thead td, .table thead th{
  color: #fff;
}
.devils{
  background-color: #8b0505d1;
  color: #fff;
}
/* scrolltable rules */
table  {     width:90%; 
    margin-left:auto; 
    margin-right:auto;  overflow: auto; }
th div { margin-top: -20px; position: absolute; }

/* design */
table { border-collapse: collapse; }
tr:nth-child(even) { background: #EEE; }

@media screen and (min-width: 1292px)
{
  .container{
    min-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// sort-table.vue?e5ba95fc